import React from 'react';
import UnsubscribeComponent from '../../../Components/UserComponents/Unsubscribe';

const UnsubscribeContainer = () => {
  return (
    <React.Fragment>
      <UnsubscribeComponent />
    </React.Fragment>
  );
};

export default UnsubscribeContainer;
